<template>
  <div class="obligation" style="background: #f8f8f8; padding-bottom:60px; margin-top:30px; ">
    <div
      style="width: 1000px; margin:0 auto;display:flex;justify-content: center
 align-content: center; overflow: hidden"
    >
      <div style="">
        <img class="img-view" src="../../../assets/images/new-img/company/11.jpg" alt />
      </div>
      <div style="flex:1;padding-left:100px;padding-top:30px;">
        <div class="apply" style="font-weight:600; font-size:30px">报名条件</div>
        <div class="county-content">
          <p>1. 高度认同生鲜行业并高度认可美菜业务模式与合作方式；</p>
          <p>2. 接受支付相应履约保证金和服务费；</p>
          <p>3. 具备5人以上团队管理经验；</p>
          <p>4. 有公司创立和经营管理经验优先。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "conditions",
  data() {
    return {
      dialogVisbility: false
    };
  }
};
</script>

<style lang="scss" scoped>
.county-content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 500;
}
.apply {
  font-size: 36px;
  color: #333333;
  font-weight: 500;
  margin-bottom: 30px;
}

.img-view {
  width: 356px;
}
</style>
